import React from "react";
import { useChecklistArb } from "../../hooks/use-arb";
import { StatusBanner } from "./status-banner";

interface TasksReminderProps {
  /**
   * Optional start date to display
   */
  startDate?: string;
}

/**
 * Banner component that displays a reminder to complete required tasks
 * with an optional start date.
 */
export function TasksReminder({ startDate }: TasksReminderProps) {
  const bundle = useChecklistArb();

  const title = bundle.getMessage("Checklist-TasksReminder-Title");

  const description = startDate ? bundle.formatMessage("Checklist-TasksReminder-StartDate", { startDate }) : undefined;

  return (
    <StatusBanner
      testId="page-header-tasks-reminder"
      title={title}
      description={description}
      largeViewPortImage={require("./svg/todo.svg").default}
      smallViewPortImage={require("./svg/todo.svg").default}
      iconClassName="todo-icon"
    />
  );
}
